import React, { ReactNode } from "react";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import { styled } from "@mui/material/styles";

interface DashboardListItemProps {
  label: ReactNode;
  leading: ReactNode;
  leadingSurface?: boolean;
  trailing?: ReactNode;
}

const DashboardListItemRoot = styled(CardContent)(() => ({
  alignItems: "center",
  backgroundColor: "#EAF6FF",
  borderRadius: "10px",
  boxSizing: "border-box",
  columnGap: "12px",
  display: "grid",
  gridTemplateColumns: "auto minmax(0, 1fr) auto",
  margin: "0 7px",
  minHeight: "78px",
  padding: "10px 12px !important",
  transition: "box-shadow 0.3s",
  width: "calc(100% - 14px)",
  "&:hover": {
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
  },
  "& .dashboard-list-item-leading": {
    alignItems: "center",
    display: "flex",
    flex: "0 0 auto",
    justifyContent: "center",
  },
  "& .dashboard-list-item-leading-surface": {
    backgroundColor: "#fff",
    borderRadius: "10px",
    minHeight: "40px",
    minWidth: "40px",
  },
  "& .dashboard-list-item-label": {
    color: "rgb(42, 53, 71)",
    display: "block",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 500,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  "& .dashboard-list-item-trailing": {
    alignItems: "center",
    display: "flex",
    flex: "0 0 auto",
    minWidth: 0,
    whiteSpace: "nowrap",
  },
}));

function DashboardListItem({
  label,
  leading,
  leadingSurface = false,
  trailing,
}: DashboardListItemProps) {
  return (
    <DashboardListItemRoot data-testid="dashboard-list-item">
      <Box
        className={`dashboard-list-item-leading${
          leadingSurface ? " dashboard-list-item-leading-surface" : ""
        }`}
      >
        {leading}
      </Box>
      <Box className="dashboard-list-item-label">{label}</Box>
      {trailing !== undefined && (
        <Box className="dashboard-list-item-trailing">{trailing}</Box>
      )}
    </DashboardListItemRoot>
  );
}

export default DashboardListItem;
